import { Component, OnInit, Input } from '@angular/core';
import { CarrierService } from '../../../../services/carrier/carrier.service';

@Component({
    selector: 'app-tsp-information',
    templateUrl: './tsp-information.component.html',
    styleUrls: ['./tsp-information.component.css'],
    standalone: false
})
export class TspInformationComponent implements OnInit {

  @Input() scaccode: string;
  @Input() businessType: string;
  carrier: any;
  constructor(private carrierService: CarrierService) { }

  ngOnInit() {
    // get carrier details
    this.getCarrierDetailsByScacCode(this.scaccode, this.businessType);
  }

  /**
	 * @description To get carrier details from scac code
     * @param scaccode: scac code of the carrier
	 */
  getCarrierDetailsByScacCode(scaccode, businessType) {
    this.carrierService.getCarrierByScacCode(scaccode, businessType).subscribe(data => {
      this.carrier = data;
    }, error => {
    });
  }

}
